/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { Reducer, combineReducers } from 'redux';

import languageProviderReducer from 'app/redux/language/reducer';
import globalReducer from 'app/redux/global/reducer';
import pmsReducer from 'app/redux/pms/reducer';
import PACSConfigurationReducer from 'app/redux/PACSConfiguration/reducer';
import xrayConfigurationReducer from 'app/redux/xrayGeneratorConfiguration/reducer';
import flatPanelConfigurationReducer from 'app/redux/flatPanelConfiguration/reducer';
import versionUpdateReducer from 'app/redux/versionUpdate/reducer';
import userInputMappingReducer from 'app/redux/userInputMapping/reducer';
import aiOnlyConfigurationReducer from 'app/redux/aiOnlyConfiguration/reducer';
import deviceParametersReducer from 'app/redux/deviceParameters/reducer';
import permissionsReducer from 'app/redux/permissions/reducer';
import teleradiologyReducer from 'app/redux/teleradiology/reducer';
import announcementsReducer from 'app/redux/announcements/reducer';
import currentStudyInfosReducer from 'app/redux/currentStudyInfos/reducer';
import routeReducer from './route/reducer';
import storageReducer from 'app/redux/storage/reducer';
import constructorConfigurationReducer from 'app/redux/constructorConfiguration/reducer';
import exportSettingsReducer from 'app/redux/exportSettings';
import viewerConfigurationReducer from 'app/redux/viewerConfiguration/reducer';
import processingReducer from 'app/redux/processing/reducer';
import rotationHistoryReducer from 'app/redux/rotationHistory/reducer';
import clinicInfoReducer from 'app/redux/clinicInfo/reducer';

/**
 * Creates the main reducer with the asynchronously loaded ones
 */
export default function createReducer<S>(asyncReducers: Record<string, Reducer<S>> = {}) {
  return combineReducers({
    route: routeReducer as Reducer<any>,
    global: globalReducer as Reducer<any>,
    language: languageProviderReducer as Reducer<any>,
    pms: pmsReducer as Reducer<any>,
    userInputMapping: userInputMappingReducer as Reducer<any>,
    viewerConfiguration: viewerConfigurationReducer as Reducer<any>,
    xRayConfiguration: xrayConfigurationReducer as Reducer<any>,
    PACSConfiguration: PACSConfigurationReducer as Reducer<any>,
    flatPanelConfiguration: flatPanelConfigurationReducer as Reducer<any>,
    versionUpdate: versionUpdateReducer as Reducer<any>,
    aiOnlyConfiguration: aiOnlyConfigurationReducer as Reducer<any>,
    deviceParameters: deviceParametersReducer as Reducer<any>,
    permissions: permissionsReducer as Reducer<any>,
    teleradiology: teleradiologyReducer as Reducer<any>,
    announcements: announcementsReducer as Reducer<any>,
    currentStudyInfos: currentStudyInfosReducer as Reducer<any>,
    storage: storageReducer as Reducer<any>,
    constructorConfiguration: constructorConfigurationReducer as Reducer<any>,
    exportSettings: exportSettingsReducer as Reducer<any>,
    processing: processingReducer as Reducer<any>,
    rotationHistory: rotationHistoryReducer as Reducer<any>,
    clinicInfo: clinicInfoReducer as Reducer<any>,
    ...asyncReducers,
  });
}
